import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Fire, Time, Tools } from '../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, TabsContainer, ListContainer } from '../Reusable'

import { ASSO_TYPE, PLACE_TYPE, ADS_MAKER_TYPE } from '../../types/types'

import FadeIn from 'react-fade-in';
import AdsList from '../Admin/Ads/AdsList' 
 
const { useHistory } = require('react-router-dom')

interface Props {
  match: any;
}
const ProAdsScreen: React.FC<Props> = (props) => {

  const history = useHistory()
  const user = useSelector(state => state.authReducer.user)
  const tab = props.match.params.tab || 'recap'

  const renderContent = () => {
    if (tab === 'recap') {
      return (renderStats())
    }
    return (renderListing())
  }

  const renderStats = () => {
    return (
      <div className="row">
        <div className="info-box col-sm">
          <span className="info-box-icon bg-success"><i className="fa fa-eye"></i></span>

          <div className="info-box-content">
            <span className="info-box-text">Total impressions</span>
            <span className="info-box-number">{user.total_impressions || 0}</span>
          </div>
        </div>

        <div className="info-box col-sm">
          <span className="info-box-icon bg-success"><i className="fa fa-hand-pointer"></i></span>

          <div className="info-box-content">
            <span className="info-box-text">Total clics</span>
            <span className="info-box-number">{user.total_views || 0}</span>
          </div>
        </div>
        <div className="info-box col-sm">
          <span className="info-box-icon bg-success"><i className="fa fa-link"></i></span>

          <div className="info-box-content">
            <span className="info-box-text">Total clics billeterie</span>
            <span className="info-box-number">{user.total_clicks || 0}</span>
          </div>
        </div>
      </div>
    )
  }

  const renderListing = () => {
    const title = tab === 'event' ? 'Evènements' : tab === 'place' ? 'Points de vente' : 'Bons plans'
    return (
      <AdsList
        title={title}
        type={tab}
        proId={user.id}
        onSelect={(item: any) => history.push('/ads/' + tab + '/' + item.id + '/info')}
        onCreate={() => history.push('/ads/' + tab + '/new')}
        />
    )
  }

  const tabs = [
    {
      title: 'Récap',
      key: 'recap',
    },
  ]
  if (user.type === ASSO_TYPE) {
    tabs.push({
      title: 'Evènements',
      key: 'event',
    })
  } else {
    tabs.push({
      title: 'Points de vente',
      key: 'place',
    })
    tabs.push({
      title: 'Evènements',
      key: 'event',
    })
    tabs.push({
      title: 'Bons plans',
      key: 'discount',
    })
  }

  return (
    <div className="wrapper">
      <Headerbar
        title={'Gestion des annonces'}
        />
      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid">

            <TabsContainer
              tab={tab}
              tabs={tabs}
              onSelect={(tab) => history.push('/app/' + tab.key)}
              />

            <FadeIn key={'fade-' + tab}>
              {renderContent()}
            </FadeIn>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(ProAdsScreen)